export const decodeURIPath = (path: string) =>
  decodeURIComponent(path).replace(/^\/+|\/+$/g, '')
